module.exports = __webpack_public_path__ + "educate-1b4548cb3365807e92ed289834574d28.svg";